import AppDispatcher from "../dispatcher/AppDispatcher"
import Constants from "../constants/Constants"
import AuthStore from "../stores/AuthStore"
import 'whatwg-fetch'
import config from 'react-global-configuration';
import cookie from 'react-cookies'
import MemberActions from './MemberActions'

var AuthActions = {

  setAuth(){
    var is_auth = false;
    let token = cookie.load('token')
    let refresh_token = cookie.load('refresh_token')

    if(token != undefined && token != ""){
      is_auth = true
      AppDispatcher.dispatch({
        actionType: Constants.AUTH, // 誰に
        is_auth: is_auth,
        token: token,
        refresh_token: refresh_token
      })
    }else{
      window.location = "/club/login"
    }

  },

  auth(loginname,password,item = null, picture = null){
    //Login
    var data = new FormData()
    data.append('grant_type', "password")
    data.append('username', loginname)
    data.append('password', password)
    data.append('client_id', "bbcthhouse")
    data.append('client_secret', "bbcthhouse")
    data.append('scope', "user")

    fetch(config.get("API_AUTH_PATH") + config.get("API_AUTH"), {
      method: 'POST',
      body: data
    }).then(function(response) {
      if(response.status != 200){
        return false;
      }else{
        return response.json()
      }
    }).then(function(data) {

      var is_auth = false;
      var token = "";
      var refresh_token = "";
      if(data.access_token){
        is_auth = true;
        token = data.access_token
        refresh_token = data.refresh_token
        cookie.save('token', token, { path: '/' })
        cookie.save('refresh_token', refresh_token, { path: '/' })

        if(picture){
          MemberActions.updatePicture(token,picture,refresh_token)
        }else{
          AppDispatcher.dispatch({
            actionType: Constants.AUTH, // 誰に
            is_auth: is_auth,
            token: token,
            refresh_token: refresh_token
          })
        }




      }else{

        cookie.remove('token',{ path: '/' })
        cookie.remove('refresh_token',{ path: '/' })
        AppDispatcher.dispatch({
          actionType: Constants.AUTH_NOUSER,
          item: item
        })
      }
    });
  },

  createNew(item){
    cookie.remove('token',{ path: '/' })
    cookie.remove('refresh_token',{ path: '/' })
    AppDispatcher.dispatch({
      actionType: Constants.AUTH_NOUSER,
      item: item
    })
  },

  create(id,type,account){

    fetch(config.get("API_PATH") + config.get("API_ACCOUNT_CREATE").url, {
      method: "POST",
      headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify({
       data:{
         "mail":account.mail,
         "name": account.name,
         "account_id": id,
         "account_type": type
       }
    })
    }).then(function(response) {

      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return response.status
      }else{
        return response.status
      }
    }).then(function(data) {
      if(data != null && data.status == 1){
        AppDispatcher.dispatch({
          actionType: Constants.ACCOUNT_CREATED
        })
      }else{
        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data
        })
      }
    })

  },




  update(name,value){

    AppDispatcher.dispatch({
      actionType: Constants.ACCOUNT_UPDATE,
      name: name,
      value:value
    })

  },

  logout(){
    cookie.remove('token',{ path: '/' })
    cookie.remove('refresh_token',{ path: '/' })
    window.location = "/club/login"

  },


}

export default AuthActions



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js